import React, { useState, useEffect } from "react";
import { Input, Row, Col } from "reactstrap";

// Redux
import { connect } from "react-redux";

//Componentes
import AttachCardV2 from "../../../components/cards/attachCardV2";
import CustomModal from "../../../components/modales/customModal";

import { functionsHttpsCallable } from "../../../utils/FirebaseStorage/firebase";

const enviarCorreo = functionsHttpsCallable("correos_envioCorreoExamenes");
const actualizarAPE = functionsHttpsCallable("ape_actualizarSolicitudEmpleo");

const mapStateToProps = (state) => ({
  usuarioActivo: state,
});

const ModalEntrevista = (props) => {
  const [userData] = useState(JSON.parse(localStorage.getItem("userData")));
  const [gradeEntrevista, setGradeEntrevista] = useState(0);
  const [updFile, setUpdFile] = useState([]);

  useEffect(() => {}, []);

  const fileExist = (filename) => {
    const newArr = props.fileList.filter(
      (file) => file.fileName.split(".")[0] == filename
    );
    return {
      exists: newArr.length > 0,
      file: newArr.length > 0 ? newArr[0] : undefined,
    };
  };

  const handleUpdate = async () => {
    let body = {
      cod_soli: props.id,
      cod_empr: userData.codigoEmpresa,
      data: {
        grd_entr: gradeEntrevista,
        cmp_stat: "VALIDACION",
      },
    };
    try {
      const req = await actualizarAPE(body);
      props.updateAPE({
        calificacionEntrevista: gradeEntrevista,
        estadoAPE: "VALIDACION",
      });
    } catch (error) {}
    props.toggle();
    props.toastSuccess("Estado Actualizado!");
  };

  return (
    <React.Fragment>
      <CustomModal
        modal={props.modal}
        toggle={() => props.toggle()}
        buttonTitle={"Actualizar"}
        onClick={() => handleUpdate()}
        buttonLoading={false}
        title={`Actualizar estado a ${props.newState}`}
      >
        <Row>
          <Col lg="4" md="4" xs="12">
            <Row>
              <AttachCardV2
                id={"ENTREVISTA"}
                subText={`Entrevista`}
                attached={updFile.length > 0 || fileExist("ENTREVISTA").exists}
                file={fileExist(`ENTREVISTA`).file}
                apeId={props.id}
                fileList={props.fileList}
                setLoading={(e) => props.setLoading(e)}
                setFileList={(e) => {
                  props.setFileList(e);
                }}
              />
            </Row>
            <Row style={{ marginLeft: "5px", marginRight: "5px" }}>
              <Input
                placeholder="Calificación"
                defaultValue={gradeEntrevista ?? 0}
                min={0}
                max={100}
                onChange={(e) => setGradeEntrevista(parseInt(e.target.value))}
                type="number"
                step="1"
              />
            </Row>
          </Col>
        </Row>
      </CustomModal>
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(ModalEntrevista);
